var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDetachedSingleFamily = function SvgDetachedSingleFamily(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38 39"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1 37.636h35.585v-2.452H1v2.452z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M34.11 35.024V6.672m-21.555 0v28.352m7.547.16v-6.922c0-1.575 1.419-2.852 3.17-2.852 1.752 0 3.171 1.277 3.171 2.852v6.922M12.555 17.578H34.05M6.934 23.535v11.332M8.62 24.793l-1.698 1.763m-1.418-2.353 1.337 1.155"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.226 22.812a3.66 3.66 0 0 0-1.241-4.64c.073-.22.121-.448.121-.69a2.173 2.173 0 0 0-4.346 0c0 .242.05.47.122.69a3.66 3.66 0 0 0-1.241 4.64 4.12 4.12 0 0 0-.848 2.504 4.14 4.14 0 1 0 8.281 0 4.12 4.12 0 0 0-.848-2.504z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26.445 29.457h7.605m-21.472 0h7.401"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M28.332 26.093h3.603v-5.097h-3.603v5.097zm-13.613-.055h3.604v-5.097h-3.604v5.098zM28.332 13.89h3.603V8.792h-3.603v5.096zm-13.613-.058h3.604V8.733h-3.604v5.098zm6.808.058h3.604V8.792h-3.604v5.096z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.336 8.111 23.33 1l13.798 7.111m-7.222-3.94v-2.55h2.453V5.39M21.883 30.297v1.46"
  })));
};
export default SvgDetachedSingleFamily;